import {api, BASE_URL} from "../config";

const CLIENTS_URL = BASE_URL + "clients/";

export function get_all_clients() {
    return api.get(CLIENTS_URL).then(res => res.data);
}

export function create_client(data) {
    return api.post(CLIENTS_URL, data).then(res => res.data);
}

export function update_client(id, data) {
    return api.put(CLIENTS_URL + id, data).then(res => res.data);
}

export function delete_client(id) {
    return api.delete(CLIENTS_URL + id).then(res => res.data);
}

export function get_client_ai_policy_preview(id) {
    return api.get(CLIENTS_URL + id + "/ai-policy-preview").then(res => res.data);
}

